import { defineMessages } from 'react-intl';

export const dictationFeedbackReasonPickerMessages = defineMessages({
  title: {
    defaultMessage: 'What went wrong?',
    id: 'uUwirvUegd',
    description: 'Title asking why a dictation output was rated poorly',
  },
  wrongWordOrName: {
    defaultMessage: 'Wrong word or name',
    id: 'cfbHC17M7R',
    description: 'Reason that a dictation output used the wrong word or name',
  },
  commandIssue: {
    defaultMessage: 'Command issue',
    id: '3O+Visn2jC',
    description: 'Reason that a dictation voice command did not work correctly',
  },
  customVocabIssue: {
    defaultMessage: 'Vocabulary issue',
    id: 'mNiPyic9Im',
    description: 'Reason that custom dictation vocabulary did not work correctly',
  },
  contentMissing: {
    defaultMessage: 'Content missing',
    id: '2NUl7/LDgu',
    description: 'Reason that expected content was missing from a dictation output',
  },
  numberDoseOrDateWrong: {
    defaultMessage: 'Number, dose or date wrong',
    id: 'os/FLEVJv8',
    description: 'Reason that a number, dose, or date was wrong in a dictation output',
  },
  other: {
    defaultMessage: 'Other',
    id: '3LYn55zFGI',
    description: 'Other reason that a dictation output was rated poorly',
  },
  otherDetailPlaceholder: {
    defaultMessage:
      "Tell us what happened. Please don't include any patient-identifying info",
    id: 'QbmF1SMk1o',
    description:
      'Placeholder requesting optional privacy-safe detail about poor dictation output',
  },
  otherDetailLabel: {
    defaultMessage: 'Additional feedback details',
    id: 'kTc0Du0GE1',
    description: 'Accessible label for optional detail about poor dictation output',
  },
  notNow: {
    defaultMessage: 'Not now',
    id: 'orLz34lio6',
    description: 'Action returning from the dictation feedback reason picker for now',
  },
  cancel: {
    defaultMessage: 'Cancel',
    id: 'H6IARgjGK5',
    description: 'Dismisses the dictation logs feedback picker without submitting',
  },
  close: {
    defaultMessage: 'Close feedback',
    id: 'ibs8+Le//v',
    description: 'Accessible label for closing the logs feedback popover',
  },
  submit: {
    defaultMessage: 'Submit',
    id: '3LHvbpEbLf',
    description: 'Action submitting selected reasons for poor dictation output',
  },
});
